import { DestroyRef, Directive, ElementRef, inject, NgZone } from '@angular/core';
import { InmCarousel } from './inm-carousel.component';

@Directive({
  selector: '[inmCarouselPrev]',
  standalone: true,
  host: {
    class: 'inm-carousel__control inm-carousel__control--prev',
    role: 'button',
  },
})
export class InmCarouselPrev {
  constructor() {
    const carousel = inject(InmCarousel);
    const element = inject(ElementRef).nativeElement as HTMLElement;
    const destroyRef = inject(DestroyRef);
    const zone = inject(NgZone);
    const handler = (event: Event) => {
      event.preventDefault();
      zone.run(() => carousel.prev());
    };

    zone.runOutsideAngular(() => {
      element.addEventListener('click', handler);
    });

    destroyRef.onDestroy(() => element.removeEventListener('click', handler));
  }
}
